import {
  IS_LOADING_GET_ALL_WINERIES, GET_ALL_WINERIES,
  IS_LOADING_GET_ALL_SUB_WINERIES, GET_ALL_SUB_WINERIES,
  IS_LOADING_GET_ALL_WAREHOUSES, GET_ALL_WAREHOUSES,
  IS_LOADING_GET_POST_ALL_REPRESENTATIVES, GET_POST_ALL_REPRESENTATIVES,
  IS_LOADING_GET_ALL_FRANCHISES, GET_ALL_FRANCHISES,
  IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION, GET_POST_PRODUCTS_BY_LOCATION,
  IS_LOADING_GET_POST_BATCHES_BY_LOCATION, GET_POST_BATCHES_BY_LOCATION,
  IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS,
  GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS
} from "../actions/types";

import Swal from "sweetalert2";
import localStorage from "../utils/hooks/useLocalStorage";
const bagSales = localStorage().getItem("bagSales");
const bagConsignations = localStorage().getItem("bagConsignations");

const initialState = {
  productMoreOrLessSaled: {
    orderedQuantity: 0,
    product: null,
  },
  utility: {
    totalPriceProductCosts: 0,
    totalPriceSubsales: 0,
    utilityProductSubsales: 0,
  },
  products: [],
  sales: [],
  subSales: [],
  bagConsignations: bagConsignations ? JSON.parse(bagConsignations) : [],
  bagSales: bagSales ? JSON.parse(bagSales) : [],
  batchesProduct: [],
  devolutions: [],
  wineries: [],
  isLoadingWineries: true,
  hasMoreWinery: true,
  skipWinery: 0,
  subWineries: [],
  isLoadingSubWineries: true,
  hasMoreSubWinery: true,
  skipSubWinery: 0,
  warehouses: [],
  isLoadingWarehouses: true,
  hasMoreWarehouses: true,
  skipWarehouses: 0,
  representatives: [],
  hasMoreRepresentatives: true,
  skipRepresentatives: 0,
  isLoadingRepresentatives: true,
  franchises: [],
  hasMoreFranchises: true,
  skipFranchises: 0,
  isLoadingFranchises: true,
  productsByLocation: [],
  hasMoreProductsByLocation: true,
  skipProductsByLocation: 0,
  isLoadingProductsByLocation: true,
  productsByLocation: [],
  hasMoreProductsByLocation: true,
  skipProductsByLocation: 0,
  isLoadingProductsByLocation: true,
  batchesByLocation: [],
  isLoadingBatchesByLocation: true,
  inventoryConsolidateProducts: [],
  isLoadingInventoryConsolidateProducts: true,
  hasMoreInventoryConsolidateProducts: true,
  skipInventoryConsolidateProducts: 0,


};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
});
export default function (state = initialState, action) {
  //lo que se manda de personasAction en el dispatch es el action
  switch (action.type) {
    case "PRODUCT_GENERAL_MORE_OR_LESS_SALED":
      return { ...state, productMoreOrLessSaled: action.payload };
    case "GET_GENERAL_UTILITY":
      return { ...state, utility: action.payload };
    case "ClEAR_CONSIGNMENTS_BAG":
      localStorage().setItem("bagConsignations", JSON.stringify([]));
      return { ...state, bagConsignations: [] };
    case "REMOVE_ITEM_CONSIGNMENTS":

      var bag = state.bagConsignations
      localStorage().setItem("bagConsignations", JSON.stringify(bag.filter(product => product._id !== action.payload._id)))
      return { ...state, bagConsignations: bag.filter(product => product._id !== action.payload._id) }
    case "CHANGE_QUANTITY_CONSIGNMENTS":
      var bag = state.bagConsignations;
      bag.map((product) => {
        if (product._id === action.payload.item._id) {
          if (action.payload.quantity <= product.stocks) {
            product.quantity = action.payload.quantity;
          }
        }
      });
      localStorage().setItem("bagConsignations", JSON.stringify(bag));
      return { ...state, bagConsignations: bag };



    case "ADD_TO_BAG_CONSIGNMENTS":
      var bag = state.bagConsignations;

      if (bag.find((product) => product._id === action.payload.product._id)) {
        bag.map((product) => {
          if (product._id === action.payload.product._id) {
            if (product.quantity + 1 <= action.payload.stocks) {
              product.quantity = product.quantity + 1;
              Toast.fire({
                icon: 'success',
                text: "Producto añadido",
              });
            }
          }
        });
      } else {
        if (action.payload.stocks > 0) {
          bag.push({
            ...action.payload.product,
            quantity: 1,
            stocks: action.payload.stocks,
            unit_price: action.payload.product.price,
          });
          Toast.fire({
            text: "Producto añadido",
          });
        }
        else {
          Toast.fire({
            icon: 'error',
            text: "Faltan productos en el inventario",
          });
        }
      }
      localStorage().setItem("bagConsignations", JSON.stringify(bag));
      return { ...state, bagConsignations: bag };





    case "GET_DEVOLUTIONS_BY_USER":
      return { ...state, devolutions: action.payload };
    case "CLEAR_BATCHES_BY_PRODUCT_AND_USER":
      return { ...state, batchesProduct: [] }

    case "SEE_BATCHES_BY_PRODUCT":
      return { ...state, batchesProduct: action.payload.batches };
    case "SEE_GENERAL_INVENTORY":
      return { ...state, products: action.payload };

    case IS_LOADING_GET_ALL_WINERIES:
      return { ...state, isLoadingWineries: true };

    case GET_ALL_WINERIES:
      let idsWineries = new Set(state.wineries.map((winery) => winery._id));

      try {
        let merge = [
          ...state.wineries,
          ...action.payload.data.filter(
            (winery) => !idsWineries.has(winery._id)
          ),
        ];
        return {
          ...state,
          hasMoreWinery: action.payload.hasMore,
          skipWinery: action.payload.skip,
          wineries: merge,
          isLoadingWineries: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }

    case IS_LOADING_GET_ALL_SUB_WINERIES:
      return { ...state, isLoadingSubWineries: true };

    case GET_ALL_SUB_WINERIES:

      let idsSubWineries = new Set(state.subWineries.map((subWinery) => subWinery._id));

      try {
        let merge = [
          ...state.subWineries,
          ...action.payload.data.filter(
            (subWinery) => !idsSubWineries.has(subWinery._id)
          ),
        ];
        return {
          ...state,
          hasMoreSubWinery: action.payload.hasMore,
          skipSubWinery: action.payload.skip,
          subWineries: merge,
          isLoadingSubWineries: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }


    case IS_LOADING_GET_ALL_WAREHOUSES:
      return { ...state, isLoadingWarehouses: true };

    case GET_ALL_WAREHOUSES:

      let idsWarehouses = new Set(state.warehouses.map((warehouse) => warehouse._id));

      try {

        let merge = [
          ...state.warehouses,
          ...action.payload.data.filter(
            (warehouse) => !idsWarehouses.has(warehouse._id)
          ),
        ];
        return {
          ...state,
          hasMoreWarehouses: action.payload.hasMore,
          skipWarehouses: action.payload.skip,
          warehouses: merge,
          isLoadingWarehouses: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }


    case IS_LOADING_GET_POST_ALL_REPRESENTATIVES:
      return { ...state, isLoadingRepresentatives: true };

    case GET_POST_ALL_REPRESENTATIVES:
      let idsRepresentatives = new Set(
        state.representatives.map((representative) => representative._id)
      );

      try {
        let merge = [
          ...state.representatives,
          ...action.payload.data.filter(
            (representative) => !idsRepresentatives.has(representative._id)
          ),
        ];

        return {
          ...state,
          hasMoreRepresentatives: action.payload.hasMore,
          skipRepresentatives: action.payload.skip,
          representatives: merge,
          isLoadingRepresentatives: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }


    case IS_LOADING_GET_ALL_FRANCHISES:
      return { ...state, isLoadingFranchises: true };

    case GET_ALL_FRANCHISES:
      let idsFranchises = new Set(
        state.franchises.map((franchise) => franchise._id)
      );

      try {
        let merge = [
          ...state.franchises,
          ...action.payload.data.filter(
            (franchise) => !idsFranchises.has(franchise._id)
          ),
        ];
        return {
          ...state,
          hasMoreFranchises: action.payload.hasMore,
          skipFranchises: action.payload.skip,
          franchises: merge,
          isLoadingFranchises: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }

      return {
        ...state,
        franchises: action.payload,
        isLoadingFranchises: false,
      };


    case IS_LOADING_GET_POST_PRODUCTS_BY_LOCATION:
      return { ...state, isLoadingProductsByLocation: true };
      case "CLEAN_POST_PRODUCTS_BY_LOCATION":
        return {
          ...state,
          hasMoreProductsByLocation: true,
          skipProductsByLocation: 0,
          productsByLocation: [],
          isLoadingProductsByLocation: true,
        };
    case GET_POST_PRODUCTS_BY_LOCATION:
      let idsProductsByLocation = new Set(
        state.productsByLocation.map((product) => product._id)
      );

      try {
        let merge = [
          ...state.productsByLocation,
          ...action.payload.data.filter(
            (product) => !idsProductsByLocation.has(product._id)
          ),
        ];

        return {
          ...state,
          hasMoreProductsByLocation: action.payload.hasMore,
          skipProductsByLocation: action.payload.skip,
          productsByLocation: merge,
          isLoadingProductsByLocation: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }


    case IS_LOADING_GET_POST_BATCHES_BY_LOCATION:
      return { ...state, isLoadingBatchesByLocation: true };

    case GET_POST_BATCHES_BY_LOCATION:

      return {
        ...state,
        batchesByLocation: action.payload,
        isLoadingBatchesByLocation: false,
      };


    case IS_LOADING_GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS:
      return { ...state, isLoadingInventoryConsolidateProducts: true };

    case GET_POST_INVENTORY_CONSOLIDATE_PRODUCTS:
      let idsInventoryConsolidateProducts = new Set(
        state.inventoryConsolidateProducts.map((product) => product._id)
      );

      try {
        let merge = [
          ...state.inventoryConsolidateProducts,
          ...action.payload.data.filter(
            (product) => !idsInventoryConsolidateProducts.has(product._id)
          ),
        ];

        return {
          ...state,
          hasMoreInventoryConsolidateProducts: action.payload.hasMore,
          skipInventoryConsolidateProducts: action.payload.skip,
          inventoryConsolidateProducts: merge,
          isLoadingInventoryConsolidateProducts: false,
        };
      } catch (e) {

        return {
          ...state,
        };
      }


    case "SEE_SUB_SALES":
      return { ...state, subSales: action.payload };

    case "GET_SALES":
      return { ...state, sales: action.payload };

    case "CLEAR_SALES":
      localStorage().setItem("bagSales", JSON.stringify([]));
      return { ...state, bagSales: [] };

    case "ADD_TO_BAG_SALES":
      var bag = state.bagSales;

      if (bag.find((product) => product._id === action.payload.product._id)) {
        bag.map((product) => {
          if (product._id === action.payload.product._id) {
            if (product.quantity + 1 <= action.payload.stocks) {
              product.quantity = product.quantity + 1;
              Toast.fire({
                icon: 'success',
                text: "Producto añadido",
              });
            }
          }
        });
      } else {
        if (action.payload.stocks > 0) {
          bag.push({
            ...action.payload.product,
            quantity: 1,
            stocks: action.payload.stocks,
            unit_price: action.payload.product.price,
          });
          Toast.fire({
            text: "Producto añadido",
          });
        }
        else {
          Toast.fire({
            icon: 'error',
            text: "Faltan productos en el inventario",
          });
        }
      }
      localStorage().setItem("bagSales", JSON.stringify(bag));
      return { ...state, bagSales: bag };

    case "REMOVE_ITEM_SALE":

      var bag = state.bagSales
      localStorage().setItem("bagSales", JSON.stringify(bag.filter(product => product._id !== action.payload._id)))
      return { ...state, bagSales: bag.filter(product => product._id !== action.payload._id) }


    //return { ...state, bagSales: bag };
    case "CHANGE_QUANTITY_SALES":
      var bag = state.bagSales;
      bag.map((product) => {
        if (product._id === action.payload.item._id) {
          if (action.payload.quantity <= product.stocks) {
            product.quantity = action.payload.quantity;
          }
        }
      });
      localStorage().setItem("bagSales", JSON.stringify(bag));
      return { ...state, bagSales: bag };

    default:
      return state;
  }
}
